export const VIPER_TITLE = "RAM powered by IMX";
export const DEFAULT_PORT = 8800;

const hostname = window.location.hostname;
// const hostname = "dockerdevhome";

const envSettings = window as any;
export const getAPIUrl = () => {
    return envSettings.API_URL ? envSettings.API_URL : `https://${hostname}:${DEFAULT_PORT}/`;
};



// WEBPACK FOOTER //
// ./src/config.ts